<template>
<div class="howToEarnPage">
  <div class="inviteFriendsBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/inviteFriendsBoxBg.png')+')'}">
    <div class="inviteFriendsToEarn" :style="{backgroundImage:'url('+require('../../assets/images/invite/inviteFriendsToEarnBg.png')+')'}">{{$t('lang.invitee.inviteFriendsToEarn')}}</div>
    <div class="inviteFriendsToEarnTip" v-if="0">{{replaceInviteFriendsToEarnTip($t('lang.invitee.inviteFriendsToEarnTip'))}}</div>
    <div class="betDepostBonusRowBox">
      <div class="teamBox">
        <div class="value" v-if="pageData && pageData.reardConfig">{{pageData.reardConfig.BetCommissionRate}}%</div>
        <div class="labelBox">
          {{$t('lang.invitee.teamBet')}}
        </div>
      </div>
      <div class="addIcon" style="left: 2vw">+</div>
      <div class="depositBox">
         <div class="value" v-if="pageData && pageData.reardConfig">{{pageData.reardConfig.DepositCommissionRate}}%</div>
        <div class="labelBox">
          {{$t('lang.invitee.teamDeposit')}}
        </div>
      </div>
      <div class="addIcon" style="left: -2vw">+</div>
      <div class="bonusBox">
         <div class="value" v-if="pageData && pageData.reardConfig">₹{{pageData.reardConfig.Capitation}}</div>
        <div class="labelBox">
          {{$t('lang.invitee.bonus')}}
        </div>
      </div>
    </div>
  </div>
  <div class="loginBtn" @click="goto('/Login')" v-if="!userInfo">{{$t('lang.invitee.loginOrRegister')}}</div>
  <div :class="userInfo?'getBoxList':'getBoxListNoLogin'">
    <div class="getBox" style="margin-top: 15vw;" @click="goRules(0)">
      <div class="title" v-html="replaceGetInvitationBonusValue($t('lang.invitee.getInvitationBonus'))"></div>
      <div class="tip">{{replaceGetInvitationBonusValue($t('lang.invitee.getInvitationBonusTip'))}}</div>
      <img style="position:absolute;height: 87%;" src="../../assets/images/invite/getInvitationBonusBox.png" alt="" class="getBoxBg">
      <div class="viewDetailsBtn">{{ $t('lang.UploadProofDetail.viewDetails') }}</div>
    </div>
    <div class="getBox" @click="goRules(1)">
      <div class="title" v-html="replaceGetInvitationBettingRewardsValue($t('lang.invitee.getInvitationBettingRewards'))"></div>
      <div class="tip">{{$t('lang.invitee.getInvitationBettingRewardsTip')}}</div>
      <img style="height: 59%;position: absolute;top: 26vw" src="../../assets/images/invite/getInvitationBettingRewardsBg.png" alt="" class="getBoxBg">
      <div class="viewDetailsBtn">{{ $t('lang.UploadProofDetail.viewDetails') }}</div>
    </div>
    <div class="getBox" @click="goRules(2)" :style="{'marginBottom': !(pageData.reardConfig && (pageData.reardConfig.VirIsOpen || pageData.reardConfig.InviteRankIsOpen)) ? '126px':'0px'}">
      <div class="title" v-html="replaceGetInvitationDepositRewardsValue($t('lang.invitee.getInvitationDepositRewards'))"></div>
      <div class="tip">{{$t('lang.invitee.getInvitationDepositRewardsTip')}}</div>
      <img style="height: 62%;position: absolute;top: 18vw" src="../../assets/images/invite/getInvitationDepositRewardsBg.png" alt="" class="getBoxBg">
      <div class="viewDetailsBtn">{{ $t('lang.UploadProofDetail.viewDetails') }}</div>
    </div>
    <div class="invitationCampaignBg" v-if="pageData.reardConfig && (pageData.reardConfig.VirIsOpen || pageData.reardConfig.InviteRankIsOpen)" :style="{'marginBottom': (pageData.reardConfig && (pageData.reardConfig.VirIsOpen || pageData.reardConfig.InviteRankIsOpen)) ? '126px':'0px'}">
      <img src="../../assets/images/invite/invitationCampaignTitleIcon.png" alt="" class="invitationCampaignIcon">
      <div class="title">{{$t('lang.invitee.invitationCampaign')}}</div>
      <div class="cashWheelBox"  :style="{backgroundImage:'url('+require('../../assets/images/invite/invitationCampaignItemBg.png')+')'}" v-if="pageData.reardConfig && pageData.reardConfig.VirIsOpen">
        <img src="../../assets/images/invite/cashWheelImg.png" alt="" class="rightImg">
        <div class="title" v-html="getCashWhellClaimBonus($t('lang.invitee.claimBonus'))"></div>
        <div class="activityName">{{$t('lang.invitee.activityNameCashWheel')}}</div>
        <div class="cashWheelTip">{{$t('lang.invitee.cashWheelTip')}}</div>
        <div class="viewDetailBtn" @click="goCashWheel()">{{$t('lang.invitee.viewDetail')}}</div>
      </div>
      <div class="leaderboardBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/invitationCampaignItemBg.png')+')'}" v-if="pageData.reardConfig && pageData.reardConfig.InviteRankIsOpen">
        <img src="../../assets/images/invite/leaderboardImg.png" alt="" class="rightImg">
        <div class="title" v-html="getLeaderboarClaimBonus($t('lang.invitee.claimBonus'))"></div>
        <div class="activityName">{{$t('lang.invitee.activityNameInviteLeaderboard')}}</div>
        <div class="cashWheelTip">{{$t('lang.invitee.LeaderboardTip')}}</div>
        <div class="viewDetailBtn" @click="goShareFiesta()">{{$t('lang.invitee.viewDetail')}}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import request from '@/service'
export default {
  name: 'howToEarnPage',
  props: ['pageData'],
  data () {
    return {
      userInfo: localStorage.getItem('userInfo')
    }
  },
  mounted () {
    console.log(this.pageData)
  },
  methods: {
    goCashWheel () {
      this.$router.push('/cashWheel')
      this.saveUserEvent('inviteGoVIR')
    },
    goShareFiesta () {
      if (!this.userInfo) {
        this.$router.push('/Login')
      } else {
        this.$router.push('/ShareFiesta')
        this.saveUserEvent('inviteGoShareFiesta')
      }
    },
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo ? this.userInfo.UserId : ''}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    getCashWhellClaimBonus (val) {
      if (this.pageData.reardConfig) {
        return val.replace('{bonus}', 5000)
      }
    },
    getLeaderboarClaimBonus (val) {
      if (this.pageData.reardConfig) {
        return val.replace('{bonus}', 3000)
      }
    },
    goto (path) {
      this.$router.push(path)
    },
    goRules (ruleType) {
      if (!this.userInfo) {
        this.$router.push('/Login')
      } else {
        this.$router.push({
          path: '/inviteRules',
          query: {
            ruleType: ruleType
          }
        })
      }
    },
    replaceInviteFriendsToEarnTip (string) {
      if (this.pageData && this.pageData.reardConfig) {
        return string.replace('{teamBet}', this.pageData.reardConfig.BetCommissionRate).replace('{teamDeposit}', this.pageData.reardConfig.DepositCommissionRate).replace('{bonus}', this.pageData.reardConfig.Capitation)
      } else {
        return string.replace('{teamBet}', '-').replace('{teamDeposit}', '-').replace('{bonus}', '-')
      }
    },
    replaceGetInvitationBonusValue (string) {
      if (this.pageData && this.pageData.reardConfig) {
        return string.replace('{bonus}', this.pageData.reardConfig.Capitation)
      } else {
        return string.replace('{bonus}', '-')
      }
    },
    replaceGetInvitationBettingRewardsValue (string) {
      if (this.pageData && this.pageData.reardConfig) {
        return string.replace('{bettingRewards}', this.pageData.reardConfig.BetCommissionRate)
      } else {
        return string.replace('{bettingRewards}', '-')
      }
    },
    replaceGetInvitationDepositRewardsValue (string) {
      if (this.pageData && this.pageData.reardConfig) {
        return string.replace('{depositRewards}', this.pageData.reardConfig.DepositCommissionRate)
      } else {
        return string.replace('{depositRewards}', '-')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.howToEarnPage{
  //border: 1px solid red;
  overflow: hidden;
  height: 100%;
  .inviteFriendsBox{
    width: 100vw;
    height: 180.711vw;
    background-size: 100% 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    //position: absolute;
    left: 0;
    padding-bottom: 20vw;
    .inviteFriendsToEarn{
      margin-top: 15.055vw;
      font-style: normal;
      font-weight: 700;
      font-size: 6.111vw;
      text-align: center;
      text-transform: capitalize;
      color: #F8FFF7;
      text-shadow: 0px 4px 15px rgba(0, 0, 0, 0.5);
      background-size: 100% 100%;
      width: 100%;
      height: 10.75vw;
      //border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .inviteFriendsToEarnTip{
      font-style: normal;
      font-weight: 500;
      font-size: 4.255vw;
      line-height: 121.99%;
      text-transform: capitalize;
      color: #E6E6E6;
      text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);
      margin-top: 3vw;
    }
    .betDepostBonusRowBox{
      width: 100vw;
      display: flex;
      align-items: center;
      gap: 2vw;
      justify-content: center;
      margin-top: -2vw;
      .teamBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2vw;
        position: relative;
        top: 6vw;
        .value{
          font-family: 'Inter';
          font-style: normal;
          font-weight: 700;
          font-size: 7.777vw;
          text-transform: capitalize;
          color: #FEFFC6;
          text-shadow: 0px 0px 4px #D2FF5F;
        }
        .labelBox{
          background-color: #6BEAFA;
          //width: 33.075vw;
          //height: 7.5vw;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 3.611vw;
          padding:0vw 3vw;
          border-radius: 10vw;
          height: 5.686vw;
        }
      }
      .depositBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2vw;
        position: relative;
        top: 6vw;
        .value{
          font-family: 'Inter';
          font-style: normal;
          font-weight: 700;
          font-size: 8.611vw;
          text-transform: capitalize;
          color: #FEFFC6;
          text-shadow: 0px 0px 4px #D2FF5F;
        }
        .labelBox{
          background-color: #6BEAFA;
          //width: 33.075vw;
          //height: 7.5vw;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 3.611vw;
          padding: 0vw 3vw;
          border-radius: 10vw;
          height: 5.686vw;
        }
      }
      .bonusBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2vw;
        position: relative;
        top: 6vw;
        .value{
          font-family: 'Inter';
          font-style: normal;
          font-weight: 700;
          font-size: 7.777vw;
          text-transform: capitalize;
          color: #FEFFC6;
          text-shadow: 0px 0px 4px #D2FF5F;
        }
        .labelBox{
          background-color: #6BEAFA;
          //width: 33.075vw;
          //height: 7.5vw;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 3.611vw;
          padding: 0vw 3vw;
          border-radius: 10vw;
          height: 5.686vw;
        }
      }
      .addIcon{
        font-size: 9vw;
        font-weight: bold;
        color: #fff;
        position: relative;
        top: 3vw;
      }
    }
  }
  .loginBtn{
    width: 90vw;
    height: 12vw;
    background: linear-gradient(90deg, #93FFC9 0%, #6BEAFA 100%);
    border-radius: 6px;
    position: relative;
    z-index: 10;
    top: -67vw;
    left: 4vw;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-weight: 700;
    font-size: 4.444vw;
  }
  .getBoxListNoLogin{
    position: absolute;
    top: 117vw;
  }
  .getBoxList{
    position: absolute;
    top: 155vw;
  }
  .getBox{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 92.538vw;
    height: 92.372vw;
    background-color: #292929;
    border-radius: 2.222vw;
    position: relative;
    color: #fff;
    //top: -70vw;
    left: 3vw;
    margin-top: 4vw;
    overflow: hidden;
    .title{
      font-size: 5.277vw;
      font-weight: 700;
      margin-top: 4vw;
      //border: 1px solid red;
      width: 80%;
      text-align: center;
    }
    .tip{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 300;
      color: #CECECE;
      margin-top: 3vw;
      line-height: 122%;
      font-size: 2.638vw;
      width: 85.555vw;
      //border: 1px solid #fff;
      letter-spacing: 0.16vw;
      //overflow-wrap: break-word;
      //word-break: break-all;
      //white-space: pre-line;
      overflow-wrap: break-word;
    }
    .viewDetailsBtn{
      width: 81.852vw;
      height: 9.672vw;
      background-color: #313131;
      color: #BCBCBC;
      font-weight: 500;
      font-size: 3.888vw;
      border-radius: 2.222vw;
      position: absolute;
      bottom: 5.027vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .getBoxBg{
      width:100%;
      height: 100%;
      overflow: hidden;
    }
  }
  .invitationCampaignBg{
    width: 92vw;
    //height: 114.444vw;
    position: relative;
    padding: 0 0 20vw 0;
    top: 2vw;
    left: 4vw;
    background-color: rgb(42,42,42);
    border-radius: 2.222vw;
    margin-bottom: 4vw;
    .invitationCampaignIcon{
      height: 3.227vw;
      width: 2.627vw;
      position: absolute;
      left: 3vw;
      top: 5.6vw;
    }
    .title{
      font-size: 5.555vw;
      font-weight: 700;
      color: #fff;
      position: absolute;
      top: 4vw;
      left: 8vw;
    }
    .cashWheelBox{
      position: relative;
      left: 1vw;
      //border: 1px solid red;
      width: 90vw;
      height: 46.555vw;
      background-size: 100% 100%;
      top: 13vw;
      .rightImg{
        position: absolute;
        right: 4vw;
        top: 4vw;
        height: 24.777vw;
        width: 24.777vw;
      }
      .title{
        font-size: 4vw;
        color: #fff;
        font-weight: 700;
        position: absolute;
        top: 5vw;
        left: 6vw;
      }
      .activityName{
        position: absolute;
        top: 12vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #808080;
      }
      .cashWheelTip{
        position: absolute;
        top: 17vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #D6D6D6;
        //border: 1px solid red;
        width: 54vw;
        line-height: 4vw;
      }
      .viewDetailBtn{
        width: 77vw;
        height: 10.455vw;
        background-color: rgb(67,72,73);
        border-radius: 1.666vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.2vw;
        color: #fff;
        font-weight: 500;
        position: absolute;
        top: 31vw;
        left: 6.5vw;
      }
    }
    .leaderboardBox{
      position: relative;
      left: 1vw;
      //border: 1px solid red;
      width: 90vw;
      height: 50.555vw;
      background-size: 100% 100%;
      top: 15vw;
      .rightImg{
        position: absolute;
        right: 4vw;
        top: 4vw;
        height: 24.777vw;
        width: 24.777vw;
      }
      .title{
        font-size: 4vw;
        color: #fff;
        font-weight: 700;
        position: absolute;
        top: 5vw;
        left: 6vw;
      }
      .activityName{
        position: absolute;
        top: 12vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #808080;
      }
      .cashWheelTip{
        position: absolute;
        top: 17vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #D6D6D6;
        //border: 1px solid red;
        width: 54vw;
        line-height: 4vw;
      }
      .viewDetailBtn{
        width: 77vw;
        height: 10.455vw;
        background-color: rgb(67,72,73);
        border-radius: 1.666vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.2vw;
        color: #fff;
        font-weight: 500;
        position: absolute;
        top: 35vw;
        left: 6.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/howToEarnPage.vue